import React from "react";
import get from "lodash/get";
import isArray from "lodash/isArray";
import omitBy from "lodash/omitBy";
import { Button, message } from "antd";

import ScenarioEditorForm from "./ScenarioEditorForm";

/**
 * The main entry point component for the scenario editor
 */
class ScenarioEditor extends React.Component {
  constructor(props) {
    super(props);

    const definition = JSON.parse(props.definition);

    const meta = {
      locale: {
        default: "nl",
        choices: [
          { id: "nl", name: "Dutch" },
          { id: "en", name: "English" },
        ],
      },
    };

    this.state = {
      meta,
      definition,
    };
  }

  handleDefinitionChange = (definition) => this.setState({ definition });

  handleSubmitButtonClick = (e) => {
    e.preventDefault();
    const { onSubmit } = this.props;
    const { definition } = this.state;

    const eventIds = get(definition, "events", []).map((x) => x.id);
    let eventsValid = true;
    get(definition, "events", []).forEach((event) => {
      if (isArray(event.next_rules)) {
        event.next_rules.forEach((x) => {
          if (!eventIds.includes(x.id)) {
            message.error(
              `Event id "${x.id}" is invalid (next rules for event id "${event.id}"`
            );
            eventsValid = false;
          }
        });
      }
    });

    if (eventsValid) {
      // Clean empty fields in events
      if (definition.events) {
        const emptyValues = ["", "<p></p>", "<p><br></p>"];
        definition.events = definition.events.map((event) =>
          omitBy(event, (value) => emptyValues.includes(value))
        );
      }
      onSubmit(JSON.stringify(definition, null, 2));
    }
  };

  render() {
    const { onMediaSelectionRequested } = this.props;
    const { meta, definition } = this.state;

    return (
      <React.Fragment>
        <ScenarioEditorForm
          meta={meta}
          definition={definition}
          onMediaSelectionRequested={onMediaSelectionRequested}
          onDefinitionChange={this.handleDefinitionChange}
        />
        <Button onClick={this.handleSubmitButtonClick}>
          Submit to scenario
        </Button>
      </React.Fragment>
    );
  }
}

export default ScenarioEditor;
